import { Component, ElementRef, OnInit } from '@angular/core';
import { ContactsService } from './contacts.service';
import { MediaHandlerService } from '../../shared/services/media-handler.service';
import { MediaService } from '../../shared/services/media.service';

@Component({
  selector: 'app-contacts',
  standalone: true,
  imports: [],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.scss'
})
export class ContactsComponent implements OnInit {
  contactsData = [];
  private mediaObserver: MutationObserver;
  constructor(private contactsService: ContactsService,
    private mediaService: MediaService,
        private elRef: ElementRef,
        private mediaHandlerService: MediaHandlerService
  ) {
  }
  ngOnInit(): void {
    this.getContactsData();    
    this.mediaHandlerService.processMedia(this.elRef.nativeElement, 'img');
    this.mediaObserver = this.mediaHandlerService.observeMedia(this.elRef.nativeElement, (type) => this.mediaHandlerService.processMedia(this.elRef.nativeElement, type));
  }
  getContactsData() {
    this.contactsService.getData().subscribe(response => {
      this.contactsData = response;
    })
  }
}
